import React from "react";
import { Link } from "react-router-dom";

const CTAAreaOne = () => {
  return (
    <div className="cta-area-1">
      {/* Imagen de fondo para el CTA */}
      <div className="cta1-bg-thumb">
        {/* Ajusta el path de la imagen según tu estructura de proyecto */}
        <img 
          src="/assets/img/bg/cta-bg1-1.png" 
          alt="Leal Chapa y Pintura" 
        />
      </div>

      <div className="container">
        <div className="cta-wrap1">
          <div className="row justify-content-md-between align-items-center">
            <div className="col-lg-6 col-md-8">
              <div className="title-area mb-md-0">
                <span className="sub-title style2 text-white">
                  Contáctanos
                </span>
                <h2 className="sec-title text-white mb-0">
                  Soluciones de mecánica, chapa y pintura para tu vehículo
                </h2>
              </div>
            </div>
            <div className="col-md-auto">
              <div className="title-area mb-0">
                {/* Ajusta la ruta /contacto al enlace real de tu sección de contacto */}
                {/* <Link className="btn" to="/contacto">
                  Más información <i className="fas fa-arrow-right ms-2" />
                </Link> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CTAAreaOne;
